import React, {useEffect, useState} from 'react'
import Groups from "./groups";
import Admins from "./admin";
import User from "./user";
import Darajat from "./darajat";
import IDS from "./ids";
import axios from "axios";
import {url} from "./BaseUrl";
import DarajatAdmin from "./darajatAdmin";
// import Test from "./test";
const tele = window.Telegram.WebApp;
const user_id = tele.initDataUnsafe?.user?.id;
tele.expand();
function Home() {
    const [activeTab, setActiveTab] = useState('groups'); // الحالة الابتدائية: عرض المجموعات
    const type_user = ["super", "admin",'darajat']
    const [info, setInfo] = useState([]);
    async function getInfo() {
       await axios.get(url+`/info/${user_id}`, {headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'Access-Control-Allow-Origin': '*'}})
            .then((res) => {
                setInfo(res.data);
                // alert(res.data.length)
            })
    }

    useEffect(() => {
        getInfo();
    }, []);
    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };
    function nivbar_super(){
        return (
            <div className={'grid grid-cols-4 my-5 font-medium justify-items-center w-full'}>
                <button className={'w-4/6 max-sm:w-5/6 text-center rounded-3xl max-sm:px-2 px-4 py-2 '+ (activeTab === 'groups' ? ' bg-[#303BFF] text-white font-bold' : ' bg-[#303BFF] bg-opacity-25 text-[#303BFF]')} onClick={() => handleTabChange('groups')}>القروبات</button>
                <button className={'w-4/6 max-sm:w-5/6 text-center rounded-3xl max-sm:px-2 px-4 py-2 '+ (activeTab === 'darajat' ? ' bg-[#303BFF] text-white font-bold' : ' bg-[#303BFF] bg-opacity-25 text-[#303BFF]')} onClick={() => handleTabChange('darajat')}>منصة درجات</button>
                <button className={'w-4/6 max-sm:w-5/6 text-center rounded-3xl max-sm:px-2 px-4 py-2 '+ (activeTab === 'admins' ? ' bg-[#303BFF] text-white font-bold' : ' bg-[#303BFF] bg-opacity-25 text-[#303BFF]')} onClick={() => handleTabChange('admins')}>Admins</button>
                <button className={'w-4/6 max-sm:w-5/6 text-center rounded-3xl max-sm:px-2 px-4 py-2 '+ (activeTab === 'user' ? ' bg-[#303BFF] text-white font-bold' : ' bg-[#303BFF] bg-opacity-25 text-[#303BFF]')} onClick={() => handleTabChange('user')}>مستخدمين</button>
                <button className={'w-4/6 max-sm:w-5/6 text-center rounded-3xl max-sm:px-2 px-4 py-2 '+ (activeTab === 'ids' ? ' bg-[#303BFF] text-white font-bold' : ' bg-[#303BFF] bg-opacity-25 text-[#303BFF]')} onClick={() => handleTabChange('ids')}>IDS</button>
            </div>
        );
    }

    function nivbar_admin(){
        return(
            <div className={'grid grid-cols-2 my-5 font-medium justify-items-center w-full'}>
                <button className={'w-4/6 text-center rounded-3xl max-sm:px-2 px-4 py-2 '+ (activeTab === 'groups' ? ' bg-[#303BFF] text-white font-bold' : ' bg-[#303BFF] bg-opacity-25 text-[#303BFF]')} onClick={() => handleTabChange('groups')}>القروبات</button>
                <button className={'w-4/6 max-sm:w-5/6 text-center rounded-3xl max-sm:px-2 px-4 py-2 '+ (activeTab === 'darajat' ? ' bg-[#303BFF] text-white font-bold' : ' bg-[#303BFF] bg-opacity-25 text-[#303BFF]')} onClick={() => handleTabChange('darajat')}>منصة درجات</button>
                <button className={'w-4/6 text-center rounded-3xl max-sm:px-2 px-4 py-2 '+ (activeTab === 'user' ? ' bg-[#303BFF] text-white font-bold' : ' bg-[#303BFF] bg-opacity-25 text-[#303BFF]')} onClick={() => handleTabChange('user')}>المستخدمين</button>
            </div>
        );
    }

    function nivbar_darajat(){
        return (
            <div className={'grid grid-cols-2 my-5 font-medium justify-items-center w-full'}>
                <button className={'w-4/6 text-center rounded-3xl max-sm:px-2 px-4 py-2 '+ (activeTab === 'groups' ? ' bg-[#303BFF] text-white font-bold' : ' bg-[#303BFF] bg-opacity-25 text-[#303BFF]')} onClick={() => handleTabChange('groups')}>القروبات</button>
                <button className={'w-4/6 text-center rounded-3xl max-sm:px-2 px-4 py-2 '+ (activeTab === 'darajatAdmin' ? ' bg-[#303BFF] text-white font-bold' : ' bg-[#303BFF] bg-opacity-25 text-[#303BFF]')} onClick={() => handleTabChange('darajatAdmin')}>منصة درجات</button>
            </div>
        );
    }

    return (
        <div>
            {info.length !== 0 && type_user.some(element => element === info.role) ?
                (
                    info.role === "super" ?
                        nivbar_super():
                    info.role === "admin" ?
                        nivbar_admin():
                    info.role === "darajat" ?
                        nivbar_darajat():
                    null
                ):(
                    // nivbar_super()
                    <div className={'grid grid-cols-2 my-5 font-medium justify-items-center w-full bg-white'}>
                        <button className={'w-4/6 text-center rounded-3xl max-sm:px-2 px-4 py-2 '+ (activeTab === 'groups' ? ' bg-[#303BFF] text-white font-bold' : ' bg-[#303BFF] bg-opacity-25 text-[#303BFF]')} onClick={() => handleTabChange('groups')}>القروبات</button>
                        <button className={'w-4/6 text-center rounded-3xl max-sm:px-2 px-4 py-2 '+ (activeTab === 'darajat' ? ' bg-[#303BFF] text-white font-bold' : ' bg-[#303BFF] bg-opacity-25 text-[#303BFF]')} onClick={() => handleTabChange('darajat')}>منصة درجات</button>
                        {/*<button className={'w-4/6 max-sm:w-5/6 text-center rounded-3xl max-sm:px-2 px-4 py-2 '+ (activeTab === 'ids' ? ' bg-[#303BFF] text-white font-bold' : ' bg-[#303BFF] bg-opacity-25 text-[#303BFF]')} onClick={() => handleTabChange('ids')}>IDS</button>*/}
                        {/*<button className={'w-4/6 text-center rounded-3xl max-sm:px-2 px-4 py-2 '+ (activeTab === 'darajatAdmin' ? ' bg-[#303BFF] text-white font-bold' : ' bg-[#303BFF] bg-opacity-25 text-[#303BFF]')} onClick={() => handleTabChange('darajatAdmin')}>darajatAdmin</button>*/}
                        {/*<button className={'w-full '} onClick={() => handleTabChange('user')}>المستخدمين</button>*/}
                        {/*<button className={'w-4/6 max-sm:w-5/6 text-center rounded-3xl max-sm:px-2 px-4 py-2 '+ (activeTab === 'admins' ? ' bg-[#303BFF] text-white font-bold' : ' bg-[#303BFF] bg-opacity-25 text-[#303BFF]')} onClick={() => handleTabChange('admins')}>Admins</button>*/}

                        {/*<button onClick={() => handleTabChange('test')}>Test</button>*/}
                    </div>
                )
            }

            {activeTab === 'groups' && <Groups />}
            {activeTab === 'admins' && <Admins />}
            {activeTab === 'user' && <User />}
            {activeTab === 'darajat' && <Darajat />}
            {activeTab === 'darajatAdmin' && <DarajatAdmin />}
            {activeTab === 'ids' && <IDS />}
            {/*{activeTab === 'test' && <Test />}*/}
        </div>
    )
}

export default Home
